import { render, staticRenderFns } from "./index.vue?vue&type=template&id=652ccb72&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=652ccb72&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=652ccb72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ccb72",
  null
  
)

export default component.exports